import { useState } from "react";
import Banner from "./sections/PageBanner";
import Footer from "./sections/PageFooter";
import PageHeader from "./sections/PageHeader";
import ReactGA from "react-ga4";

ReactGA.initialize("G-FMCF2WQ3F6");

const contacts = [
  {
    icon: (
      <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8} className="w-5 h-5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10" />
      </svg>
    ),
    label:  'Email us',
    value:  'info@lapa.africa',
    href:   'mailto:info@lapa.africa',
    detail: 'We respond within 1&ndash;2 business days.',
  },
  {
    icon: (
      <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8} className="w-5 h-5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M14 9a2 2 0 0 1-2 2H6l-4 4V4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5Z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1" />
      </svg>
    ),
    label:  'Browse FAQs',
    value:  'Visit the FAQ centre',
    href:   '/faqs',
    detail: 'Answers to the most common questions about WITS.',
  },
  {
    icon: (
      <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8} className="w-5 h-5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
      </svg>
    ),
    label:  'Headquarters',
    value:  'Nairobi, Kenya',
    href:   '#',
    detail: 'Operating across East &amp; Southern Africa.',
  },
];

function PageHero() {
  return (
    <div
      className="relative w-full overflow-hidden flex flex-col justify-end"
      style={{ height: '46vh', minHeight: 320, background: '#052e16' }}
    >
      <img
        src="/images/v1/img12.jpg"
        alt=""
        className="absolute inset-0 w-full h-full object-cover select-none"
        style={{ opacity: 0.28 }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#052e16]/20 via-transparent to-[#052e16]/95 pointer-events-none" />
      <div className="relative z-10 max-w-7xl mx-auto w-full px-6 lg:px-10 pb-12">
        <span className="flex items-center gap-3 mb-4">
          <span className="h-px w-8 bg-green-400" />
          <span className="text-green-400 text-xs tracking-[0.22em] uppercase font-medium" style={{ fontFamily: 'var(--font-body)' }}>
            Get In Touch
          </span>
        </span>
        <h1
          className="text-5xl lg:text-6xl font-bold text-white leading-tight"
          style={{ fontFamily: 'var(--font-display)', textShadow: '0 2px 24px rgba(0,0,0,0.5)' }}
        >
          Contact <span className="text-green-400">Us</span>
        </h1>
        <p
          className="mt-4 text-white/65 text-base max-w-lg leading-relaxed"
          style={{ fontFamily: 'var(--font-body)', textShadow: '0 1px 8px rgba(0,0,0,0.5)' }}
        >
          Whether you&apos;re a ranger, researcher, institution, or partner &mdash; we&apos;d love
          to hear from you.
        </p>
      </div>
    </div>
  );
}

function ContactBody() {
  const [sent, setSent] = useState(false);

  const inputCls =
    'w-full px-4 py-3 rounded-xl bg-white border border-gray-200 text-gray-900 text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500/40 focus:border-green-500 transition-all';

  return (
    <div className="w-full bg-[#fafaf7] py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-5 gap-16">

          {/* Form */}
          <div className="lg:col-span-3">
            <h2 className="text-3xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'var(--font-display)' }}>
              Send us a message
            </h2>
            <p className="text-gray-500 text-sm mb-8" style={{ fontFamily: 'var(--font-body)' }}>
              Fill in the form and our team will get back to you promptly.
            </p>

            {sent ? (
              <div className="flex flex-col items-center justify-center gap-4 py-16 rounded-2xl border border-green-200 bg-green-50">
                <div className="w-12 h-12 rounded-full bg-green-600 flex items-center justify-center">
                  <svg fill="none" viewBox="0 0 24 24" stroke="white" strokeWidth={2.5} className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <p className="text-green-800 font-semibold text-lg" style={{ fontFamily: 'var(--font-display)' }}>
                  Message sent!
                </p>
                <p className="text-green-700/70 text-sm" style={{ fontFamily: 'var(--font-body)' }}>
                  We&apos;ll get back to you within 1&ndash;2 business days.
                </p>
              </div>
            ) : (
              <form onSubmit={(e) => { e.preventDefault(); setSent(true); }} className="flex flex-col gap-4">
                <div className="grid sm:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="firstName" className="sr-only">First Name</label>
                    <input id="firstName" type="text" placeholder="First name" className={inputCls} required />
                  </div>
                  <div>
                    <label htmlFor="lastName" className="sr-only">Last Name</label>
                    <input id="lastName" type="text" placeholder="Last name" className={inputCls} required />
                  </div>
                </div>
                <div>
                  <label htmlFor="contactEmail" className="sr-only">Email</label>
                  <input id="contactEmail" type="email" placeholder="Email address" className={inputCls} required />
                </div>
                <div>
                  <label htmlFor="organisation" className="sr-only">Organisation</label>
                  <input id="organisation" type="text" placeholder="Organisation (optional)" className={inputCls} />
                </div>
                <div>
                  <label htmlFor="subject" className="sr-only">Subject</label>
                  <select id="subject" className={inputCls} defaultValue="">
                    <option value="" disabled>Subject</option>
                    <option>Partnership enquiry</option>
                    <option>Technical support</option>
                    <option>Media &amp; press</option>
                    <option>Incident reporting</option>
                    <option>General question</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="message" className="sr-only">Message</label>
                  <textarea
                    id="message"
                    rows={5}
                    placeholder="Your message…"
                    className={inputCls}
                    style={{ resize: 'none' }}
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="w-full py-3.5 rounded-full bg-green-700 text-white text-sm font-semibold hover:bg-green-600 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-green-200"
                  style={{ fontFamily: 'var(--font-body)' }}
                >
                  Send Message &rarr;
                </button>
              </form>
            )}
          </div>

          {/* Contact info */}
          <div className="lg:col-span-2 flex flex-col gap-5 lg:pt-16">
            {contacts.map((c) => (
              <a
                key={c.label}
                href={c.href}
                className="group flex gap-5 p-5 rounded-2xl border border-gray-200 bg-white hover:border-green-300 hover:shadow-md hover:shadow-green-100/60 transition-all duration-300"
              >
                <div className="shrink-0 w-10 h-10 rounded-xl bg-green-50 border border-green-100 flex items-center justify-center text-green-700 group-hover:bg-green-700 group-hover:text-white group-hover:border-green-700 transition-all duration-300">
                  {c.icon}
                </div>
                <div>
                  <p className="text-xs text-gray-400 uppercase tracking-wider mb-0.5" style={{ fontFamily: 'var(--font-body)' }}>
                    {c.label}
                  </p>
                  <p className="text-gray-900 font-semibold text-sm group-hover:text-green-700 transition-colors" style={{ fontFamily: 'var(--font-body)' }}>
                    {c.value}
                  </p>
                  <p className="text-gray-400 text-xs mt-1 leading-snug" style={{ fontFamily: 'var(--font-body)' }}
                    dangerouslySetInnerHTML={{ __html: c.detail }} />
                </div>
              </a>
            ))}

            <div className="mt-1 rounded-2xl overflow-hidden" style={{ background: '#052e16', border: '1px solid rgba(74,222,128,0.15)' }}>
              <div className="p-6">
                <p className="text-green-400 text-xs tracking-[0.15em] uppercase mb-3 font-medium" style={{ fontFamily: 'var(--font-body)' }}>
                  About LAPA Africa
                </p>
                <p className="text-white/65 text-sm leading-relaxed" style={{ fontFamily: 'var(--font-body)' }}>
                  Lawyers for Animal Protection in Africa &mdash; using law, technology, and community
                  action to defend wildlife and hold offenders accountable.
                </p>
                <a
                  href="https://lapa.africa"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1 mt-4 text-green-400 text-xs font-semibold hover:text-green-300 transition-colors"
                  style={{ fontFamily: 'var(--font-body)' }}
                >
                  Visit lapa.africa &rarr;
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default function ContactUs() {
  ReactGA.send({ hitType: "pageview", page: "/contact-us", title: "Contact Us" });
  return (
    <>
      <Banner />
      <PageHeader />
      <PageHero />
      <ContactBody />
      <Footer />
    </>
  );
}
